import React from "react"
import Layout2 from './../components/layout/layout-2'
import SEO from './../components/seo/seo';
import Howjsay from "../components/howjsay";



const SecondPage = () => (
  <Layout2>
    <SEO title="Howjsay" />
    <Howjsay />
  </Layout2>
)

export default SecondPage
